import React from "react";
import { FaRedo } from "react-icons/fa";

export default function InfrastructureListingsFiltersPanel({
  txOptions = [],
  availabilityOptions = [],
  ownershipOptions = [],
  propertyTypeOptions = [],
  showPropertyTypeFilter = false,
  stateOptions = [],
  cityOptions = [],
  trans = new Set(),
  availability = new Set(),
  ownership = new Set(),
  propertyTypes = new Set(),
  states = new Set(),
  cities = new Set(),
  onlyNew = false,
  budgetMinLakh = 0,
  budgetMaxLakh = 1000,
  budgetFillStyle = {},
  budgetSliderMaxLakh = 1000,
  budgetSliderStepLakh = 0.1,
  formatBudgetLakhLabel,
  onToggle,
  onOnlyNewChange,
  onBudgetMinChange,
  onBudgetMaxChange,
  onClear,
}) {
  return (
    <aside className="product-marketplace-filters">
      <div className="product-marketplace-filters__head">
        <h2>Filters</h2>
        <button type="button" onClick={onClear}>
          Clear All
        </button>
      </div>

      {txOptions.length ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">Transaction Type</span>
          <div className="ile-search-filter-block ile-search-filter-block--inline">
            {txOptions.map((t) => (
              <label key={t.value} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={trans.has(t.value)}
                  onChange={() => onToggle?.("trans", t.value)}
                />
                <span>{t.label}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      {availabilityOptions.length ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">Availability</span>
          <div className="ile-search-filter-block ile-search-filter-block--inline">
            {availabilityOptions.map((t) => (
              <label key={t.value} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={availability.has(t.value)}
                  onChange={() => onToggle?.("availability", t.value)}
                />
                <span>{t.label}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      {ownershipOptions.length ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">Lister Type</span>
          <div className="ile-search-filter-block ile-search-filter-block--inline">
            {ownershipOptions.map((t) => (
              <label key={t.value} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={ownership.has(t.value)}
                  onChange={() => onToggle?.("ownership", t.value)}
                />
                <span>{t.label}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      {showPropertyTypeFilter ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">Property Type</span>
          <div className="ile-search-filter-block ile-search-filter-block--inline">
            {propertyTypeOptions.map((t) => (
              <label key={t.value} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={propertyTypes.has(t.value)}
                  onChange={() => onToggle?.("propertyTypes", t.value)}
                />
                <span>{t.label}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      {stateOptions.length ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">State / Region</span>
          <div className="ile-search-states">
            {stateOptions.map((state) => (
              <label key={state} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={states.has(state)}
                  onChange={() => onToggle?.("states", state)}
                />
                <span>{state}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      {cityOptions.length ? (
        <div className="product-marketplace-filters__field">
          <span className="product-marketplace-filters__label">City</span>
          <div className="ile-search-cities">
            {cityOptions.slice(0, 20).map((city) => (
              <label key={city} className="ile-search-checkbox">
                <input
                  type="checkbox"
                  checked={cities.has(city)}
                  onChange={() => onToggle?.("cities", city)}
                />
                <span>{city}</span>
              </label>
            ))}
          </div>
        </div>
      ) : null}

      <div className="product-marketplace-filters__field">
        <span className="product-marketplace-filters__label">Budget Range (₹)</span>
        <div className="ile-budget-range">
          <div className="ile-budget-range__slider">
            <div className="ile-budget-range__track" aria-hidden />
            <div className="ile-budget-range__fill" style={budgetFillStyle} aria-hidden />
            <input
              type="range"
              className="ile-budget-range__input ile-budget-range__input--min"
              min={0}
              max={budgetSliderMaxLakh}
              step={budgetSliderStepLakh}
              value={budgetMinLakh}
              onChange={(e) => onBudgetMinChange?.(Number(e.target.value))}
              aria-label="Minimum budget in lakhs"
            />
            <input
              type="range"
              className="ile-budget-range__input ile-budget-range__input--max"
              min={0}
              max={budgetSliderMaxLakh}
              step={budgetSliderStepLakh}
              value={budgetMaxLakh}
              onChange={(e) => onBudgetMaxChange?.(Number(e.target.value))}
              aria-label="Maximum budget in lakhs"
            />
          </div>
          <div className="ile-budget-range__labels">
            <span>{formatBudgetLakhLabel?.(budgetMinLakh)}</span>
            <span>{formatBudgetLakhLabel?.(budgetMaxLakh)}</span>
          </div>
        </div>
      </div>

      <div className="product-marketplace-filters__field">
        <label className="ile-search-checkbox">
          <input type="checkbox" checked={onlyNew} onChange={(e) => onOnlyNewChange?.(e.target.checked)} />
          <span>New listings (last 7 days)</span>
        </label>
      </div>

      <button type="button" className="product-marketplace-filters__reset" onClick={onClear}>
        <FaRedo aria-hidden /> Reset Filters
      </button>
    </aside>
  );
}
